module.exports = __webpack_public_path__ + "static/media/Kids.c2028508.jpg";